export const getTargetingRules = (state) => state.target.targetingRules;
export const getTargetingRulesError = (state) =>
  state.target.targetingRulesError;
export const getTargeting = (state) => state.target;
export const getTargetings = (state) => state.target.targetingLists;
export const getDeletedTargetingRules = (state) =>
  state.target.deletedTargetingRules;
export const getSelectedFilter = (state) => state.target.selectedFilter;
